import { TFunction } from 'i18next'
import { ExternalLinks } from 'constants/ExternalLinks'
import { AgreementLabelMapping } from 'pages/Verification/Review/helpers/mappings'
import { AgreementLink } from 'pages/Verification/Review/helpers/types'
import { AgreementBaseData } from 'types/accounts'

export const getAgreementLinks = (
  agreements: AgreementBaseData[],
  t: TFunction
): AgreementLink[] => {
  const privacyPolicyLink: AgreementLink = {
    id: 'privacyPolicy',
    label: t('bvnkPrivacyPolicy'),
    url: ExternalLinks.privacyPolicy,
  }
  const agreementLinks: AgreementLink[] =
    agreements?.map(({ name, url }) => {
      const agreementLabel = AgreementLabelMapping?.[name]
      return {
        id: name,
        label: agreementLabel ? t(`verification.agreements.${agreementLabel}`) : name,
        url,
      }
    }) ?? []
  return [...agreementLinks, privacyPolicyLink]
}
